import axios from "axios";
import { getToken } from "../../../auth";
import { PersonalDetail } from "./model";

//BASE_URL
const API_URL = process.env.REACT_APP_SKYX_API_URL;
// Employer
export const ADDRESS_URL = `${API_URL}/profile`;
export const PERSONAL_DETAIL_URL = `${API_URL}/profile/personalDetails`;
export const EXPERIENCE_DETAIL_URL = `${API_URL}/profile/workExperience`;
export const UPDATE_PROFILE_URL = `${API_URL}/profile/update-profile-photo`;
export const RESUME_DETAIL_URL = `${API_URL}/profile/resume`;
export const POSTINGJOBSLIST_URL = `${API_URL}/postingjobs`;

function getUserLists() {
  var res = axios.get(`${API_URL}/profile/listUserProfile`, getToken());
  return res;
}

// Employer // 
export function editVisa(data: any) {
  return axios.post(`${API_URL}/profile/editVisaDetails`, data, getToken());
}
//GET STATES
const getStates = async (countryId: any) => {
  const res = await axios.get(`${ADDRESS_URL}/states/${countryId}`, getToken());
  return res;
};
//VIEW USER
export function getUserProfile(id: any) {
  return axios.get(`${API_URL}/profile/viewProfile/${id}`, getToken());
}
const editPersonalDetail = (
  data: PersonalDetail
): Promise<PersonalDetail | undefined> => {
  return axios
    .post(`${API_URL}/profile/editPersonalDetails`, data, getToken())
    .then((response) => {
      return response.data;
    });
};
//CREATE EXPERIENCE DETAIL
const editExperienceDetail = (data: FormData) => {
  return axios
    .post(`${API_URL}/profile/editWorkExperience`, data, getToken())
    .then((response) => {
      return response.data;
    });
};
//PROFILE PHOTO
export function editSocialMedia(data: any) {
  return axios.post(
    `${API_URL}/profile/editSocialMediaDetails`,

    data,

    getToken()
  );
}
//GET Languages
const getLanguages = async () => {
  const res = await axios.get(`${ADDRESS_URL}/languages`, getToken());
  return res;
};
// Resume Upload
const resumeUpload = (data: FormData) => {
  console.log("resume data",data)
    return axios.post(RESUME_DETAIL_URL, data, getToken()).then((response) => {
      return response.data;
    });
  };
//Skill
export function editSkill(data: any) {
  return axios.post(`${API_URL}/profile/editSkillDetails`, data, getToken());
}
//Edit Expectation
export function editExpectation(data: any) {
  return axios.post(
    `${API_URL}/profile/editExpectationDetails`,
    data,
    getToken()
  );
} 
//Edit Education
export function editEducation(data: any) {
  return axios.post(
    `${API_URL}/profile/editEducationDetails`,
    data,
    getToken()
  );
}
//PROFILE PHOTO
export function updateSocialMedia(data: any) {
  return axios.post(`${API_URL}/profile/socialMediaDetails`, data, getToken());
}

//skill
export function updateSkill(data: any) {
  return axios.post(`${API_URL}/profile/skillDetails`, data, getToken());
}
//PROFILE PHOTO
export function updatePhoto(data: FormData) {  
  return axios.post(
    `${API_URL}/profile/profilePictureDetails`,

    data,

    getToken()
  );
}
//CREATE PERSONAL DETAIL
const personalDetail = (
  data: PersonalDetail
): Promise<PersonalDetail | undefined> => {
  return axios.post(PERSONAL_DETAIL_URL, data, getToken()).then((response) => {
    return response.data;
  });
};
//CREATE EXPERIENCE DETAIL
const experienceDetail = (data: FormData) => {
  return axios
    .post(EXPERIENCE_DETAIL_URL, data, getToken())
    .then((response) => {
      return response.data;
    });
};
//Expectation
export function updateExpectation(data: any) {
  return axios.post(
    `${API_URL}/profile/expectationDetails`,

    data,

    getToken()
  );
}
export function editProfilePhoto(data: FormData) {
  console.log("data", data);
  return axios.post(
    // `${API_URL}/profile/profilePictureDetails`,
    `${UPDATE_PROFILE_URL}`,

    data,

    getToken()
  );
}
//Education
export function updateEducation(data: any) {
  return axios.post(
    `${API_URL}/profile/educationDetails`,

    data,

    getToken()
  );
}
//PURSUE EMPLOYMENT
const pursueEmployment = async (userId: any, pursueValue: any) => {
  const res = await axios.post(
    `${API_URL}/profile/pursueEmployment/${userId}/${pursueValue}`,
    "",
    getToken()
  );

  return res;
};

//  PostJobs
const getPostingJobsList = async ( filterData: any) => {
  const response = await axios
    .post(`${POSTINGJOBSLIST_URL}/postingjobs-filter`, filterData);
  return response.data;
};

  // change Link
// const getUserFavorite = async ( filterData: any,) => {
//   const response = await axios
//     .post(`${ADDRESS_URL}/user-favorite`, filterData,getToken());
//   return response.data;
// };

// Posting Jobs EmployeeList
const userFavoriteList = async (id:any) => {
  console.log("user-favoriteList response---api - id",id);
  const response = await axios
    .post(`${ADDRESS_URL}/user-favorite`,id,getToken());
  console.log("user-favoriteList response---api - req",response);
  console.log("user-favoriteList response.data---api - req",response.data);

  return response.data;
};


export { 
  getUserLists,
  getLanguages,
  getStates,
  editPersonalDetail,
  editExperienceDetail,
  resumeUpload ,
  experienceDetail,
  personalDetail,
  pursueEmployment,
  getPostingJobsList,
  // getUserFavorite
  userFavoriteList
};
